import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { models, service, Embed } from 'powerbi-client';
import { PowerBIEmbedModule, PowerBIReportEmbedComponent, PowerBIVisualEmbedComponent } from 'powerbi-client-angular';


@Component({
  selector: 'app-powerbi',
  templateUrl: './powerbi.component.html',
  styleUrls: ['./powerbi.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [PowerBIEmbedModule]
})
export class PowerbiComponent {

  @Input() token: string;
  @Input() reportid: string;
  @Input() pageid: string;
  @Input() groupid: string;
  @Input() visualid: string;
  @Input() filters: any;

  @ViewChild(PowerBIVisualEmbedComponent) reportObj!: PowerBIVisualEmbedComponent;
  @ViewChild('reportEmbed') reportEmbed: any;

  @Output() productFilterChanged = new EventEmitter<Array<string>>();

  embedConfig: models.IVisualEmbedConfiguration;
  eventHandlersMap: Map<any, any>;
  report;
  phasedEmbeddingFlag;
  visuals: models.IVisual;


  //All configuration items for Power BI component are registered in this part
  ngOnInit(): void {

    this.phasedEmbeddingFlag = false;

    //Here the event Handlers are defined
    this.eventHandlersMap = new Map([
      ['loaded', () => {
        console.log('Report has loaded');
      },
      ],
      ['rendered', () => {
        console.log("Report has Rendered");
      }],
      ['error', (event?: service.ICustomEvent<any>) => {
        console.log(event);
        if (event) {
          console.error(event.detail);

        }
      },
      ],
    ]) as Map<string, (event?: service.ICustomEvent<any>, embeddedEntity?: Embed) => void | null>;

    this.visuals = {
      name: '',
      type: '',
      title: ''
    }
    //This is the main configuration of the embedded power bi
    this.embedConfig = {
      type: "visual",
      id: this.reportid,
      pageName: this.pageid,
      visualName: this.visualid,
      embedUrl:
        "https://app.powerbi.com/reportEmbed?reportId=" + this.reportid + "&groupId=" + this.groupid,
      accessToken: this.token,
      permissions: models.Permissions.All,
      tokenType: models.TokenType.Embed,
      filters: this.filters,
      settings: {
        background: models.BackgroundType.Transparent,
        visualSettings: {
          visualHeaders: [
            {
              settings: {
                visible: false,
              }
            },
          ],
        },
        panes: {
          filters: {
            visible: false,
          },
          pageNavigation: {
            visible: false,
          },
        },
        layoutType: models.LayoutType.Custom,
        customLayout: {
          displayOption: models.DisplayOption.FitToWidth,
          reportAlignment: models.ReportAlignment.Left,
        },
        
      }
    }

  }

  ngAfterViewInit(): void {
    // this.report = this.reportObj.getReport();
    // this.report["iframe"].setAttribute('title', 'Power BI Embedded Report');
    // this.report.removeFilters();
  }

}
